export default "__VITE_ASSET__DlSsVSKP__"